import { render } from "./ViewList.vue?vue&type=template&id=21fa42cd&scoped=true&ts=true"
import script from "./ViewList.vue?vue&type=script&lang=ts"
export * from "./ViewList.vue?vue&type=script&lang=ts"

import "./ViewList.vue?vue&type=style&index=0&id=21fa42cd&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fa42cd"]])

export default __exports__